query GetSubmissions($input: FormSubmissionsInput!) {
    submissions(input: $input) {
        submissions {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
                startCursor
            }
            edges {
                node {
                    id
                    primaryEntity {
                        name
                        id
                        __typename
                        relatedEmailAddresses {
                            primary {
                                value {
                                    address
                                }
                            }
                        }
                        htmlUrl
                        htmlUrlPath
                        avatarUrl
                    }
                    id
                    submissionId
                    submissionTime
                    fields {
                        totalCount
                        __typename
                        edges {
                            fieldValue {
                                ... on FormFieldSubmissionValueSubfields {
                                    subfieldValues {
                                        name
                                        value
                                        label
                                    }
                                }
                                ... on FormFieldSubmissionValueMultiple {
                                    values
                                }
                                ... on FormFieldSubmissionValueSingle {
                                    value
                                }
                            }
                            node {
                                id
                                label
                                entityName
                                fieldName
                                originalFieldId
                            }
                        }
                    }
                }
            }
        }
    }
}
